import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

const Loading = () => (
  <div className="min-h-screen bg-[#050A14] text-white flex items-center justify-center">
    <div className="text-center">
      <div className="inline-block h-10 w-10 border-2 border-brand-cyan border-t-transparent rounded-full animate-spin" />
      <div className="mt-4 text-xs tracking-[0.3em] uppercase font-mono text-brand-cyan/80">Authenticating</div>
    </div>
  </div>
);

export const ProtectedRoute = ({ role, children }) => {
  const { user } = useAuth();
  const location = useLocation();
  if (user === undefined) return <Loading />;
  if (!user) return <Navigate to="/learning-hub" replace state={{ from: location }} />;
  if (role && user.role !== role && !(role === 'student' && user.role === 'admin')) {
    return <Navigate to={user.role === 'admin' ? '/admin' : '/student'} replace />;
  }
  return children;
};

export default ProtectedRoute;
